import LinkTableFormDialog from './link-table-form-dialog'

export default class TableFromDialog {
    Vue;
    instance;

    constructor(Vue) {
        this.Vue = Vue
        this.Vue.prototype.$nextTick(() => {
            this.instance = new Vue(LinkTableFormDialog).$mount()
            document.body.appendChild(this.instance.$el)
        })
    }

    /**
     * 弹出表格表单编辑对话框
     * @author  韦胜健
     * @date    2019/3/26 09:25
     */
    pick(option, columns) {
        this.instance.show(option, columns)
    }

    close() {
        this.instance.p_show = false
    }
}
